import { ITopViewItems } from '@/interfaces/attendance.model';

export default function TopLable({
  items,
  isMoreData = false,
}: {
  items: ITopViewItems[];
  isMoreData?: boolean;
}) {
  return (
    <div className="top-cards-row flex-wrap">
      {items &&
        items?.length > 0 &&
        items?.map((data, i) => {
          return (
            <div key={i} className="card dash-cards ">
              <div className="card-body p-3">
                <div className="d-flex align-items-center gap-3">
                  <span className="rounded-4 d-flex align-items-center justify-content-center icon_span">
                    {data?.icon}
                  </span>
                  <div className={isMoreData ? 'title_box' : ''}>
                    <h1
                      className={isMoreData ? 'heading_title' : 'text-nowrap'}
                    >
                      {data?.label}:
                    </h1>
                    <h2>{data?.value}</h2>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
}
